import {observer} from "mobx-react";
import {useStore} from "../../../stores/Store";
import {RightHandSystem} from "../../../models/RightHandSystem";
import CheckboxFilter from "./CheckboxFilter";

export default observer(function KeysOrButFilter(){
    const {LanguageStore, AccordionStore} = useStore();
    const {currentLanguageMessages} = LanguageStore;
    const {filteredRightSystem, setFilteredRightSystem} = AccordionStore;

    return (
        <CheckboxFilter
            filteredValue={filteredRightSystem}
            setFilteredValue={setFilteredRightSystem}
            title={currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.title}
            checkObjects={[
                {value: RightHandSystem.Button, label: currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.buttons},
                {value: RightHandSystem.Piano, label: currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.keys}
            ]}
            attributeName={'keysOrBut'}
        />
    )
})